export default "__VITE_ASSET__CMhdBy$5__"